import {planTypes} from "@/common/constants";
import { mapGetters } from 'vuex';

export default {
  key: planTypes.ZOOM_CLIPS,
  data() {
    return {
      title: this.$t('billing.zoom_clips_plus.title'),
      subtitle: '',
      planType: planTypes.ZOOM_CLIPS,
      logo: require('@/assets/plans/zoom-clips-plus.svg'),
    }
  },
  computed: {
    ...mapGetters(['getTypeGroupSelectedPlans']),
    trackingPlanKey() {
      return this.trackingPlanName
    },
    selectedPlan() {
      return this.getTypeGroupSelectedPlans[this.planType]?.[0];
    },
  },
};
